<template>
  <div class="base-modal">
    <div class="modal-wrapper">
      <div ref="target">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
import { onClickOutside } from '@vueuse/core'
import { ref } from 'vue'

const target = ref(null)

const emits = defineEmits(['outside'])

onClickOutside(target, (event) => emits('outside'))
</script>

<style scoped lang="postcss">
.modal-wrapper {
  @apply fixed inset-0 z-99;
  @apply flex flex-col items-center justify-center;
  @apply bg-black bg-opacity-70;
}
</style>
